import { RootStateOrAny, useSelector } from "react-redux";

const useGetStats = () => {
  const resourcesStats = useSelector((state: RootStateOrAny) => {
    return state.reports && state.reports.resourcesStats;
  });

  return { resourcesStats };
};

export default useGetStats;
